// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1SavePatientDefaultResponse {
    static getAttributeTypeMap() {
        return HubV1SavePatientDefaultResponse.attributeTypeMap;
    }
}
HubV1SavePatientDefaultResponse.discriminator = undefined;
HubV1SavePatientDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "HubV1SavePatientDefaultResponseData"
    }
];
//# sourceMappingURL=hubV1SavePatientDefaultResponse.js.map